import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MapTrifold, CaretRight } from "@phosphor-icons/react";
import ClubDashboard from "@/pages/ClubDashboard";
import { ChecklistFiles, GoalsCard, DiscussionCard, MeetingsCard, BoardSummary } from "@/components/GovBrief";

function OfficialBrief({ clubId }) {
  const [brief, setBrief] = useState(null);
  const load = () => api.get(`/clubs/${clubId}/brief`).then((r) => setBrief(r.data)).catch(() => {});
  useEffect(() => { load(); }, [clubId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!brief) return null;
  const complete = async () => {
    try { await api.post(`/clubs/${clubId}/gov/complete`); toast.success("Visit marked completed"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="mt-6 max-w-4xl" data-testid="gov-brief">
      <h2 className="c-group-title mb-2">Documents needed
        <span className="c-label ml-2">
          {brief.prep_status === "submitted" ? (brief.submitted_incomplete ? "Submitted by the club (incomplete)" : "Submitted by the club") : "In progress"}
          {brief.completed && " · Visit completed"}
        </span>
      </h2>
      {brief.outstanding.length > 0 && (
        <p className="t-support mb-2" style={{ color: "#7A4B00" }} data-testid="outstanding-items">
          Still needed: {brief.outstanding.join(", ")}
        </p>
      )}
      <ChecklistFiles clubId={clubId} data={brief} reload={load} />
      <BoardSummary clubId={clubId} />
      <MeetingsCard clubId={clubId} />
      <GoalsCard clubId={clubId} />
      <DiscussionCard clubId={clubId} />
      {brief.can_complete && (
        <button data-testid="complete-gov-button" onClick={complete}
          className="mt-6 w-full sm:w-auto px-8 py-3 rounded-full font-bold text-[16px]"
          style={{ background: "#F7A81B", color: "#3A2A00" }}>
          Mark visit completed
        </button>
      )}
    </div>
  );
}

// Individual club GOV screen for DG/DS and district officials.
export default function ClubGov() {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [visit, setVisit] = useState(undefined);

  useEffect(() => {
    api.get("/me/home").then((r) => setMe(r.data)).catch(() => setMe({}));
    api.get(`/dashboard/club/${clubId}`).then((r) => setVisit(r.data.visit)).catch(() => setVisit(null));
  }, [clubId]);

  return (
    <div data-testid="club-gov-screen">
      {visit !== undefined && (
        <div className="max-w-4xl mb-5 flex flex-wrap gap-2">
          {visit ? (
            <button data-testid="open-visit-brief-button" onClick={() => navigate(`/gov/visits/${visit.gov_visit_id}`)}
              className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold rounded-full active:scale-95">
              <MapTrifold size={15} weight="bold" /> Open visit details <CaretRight size={13} weight="bold" />
            </button>
          ) : me?.can_initiate ? (
            <button data-testid="initiate-gov-button" onClick={() => navigate("/gov/ops")}
              className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold rounded-full active:scale-95">
              <MapTrifold size={15} weight="bold" /> Plan a visit
            </button>
          ) : null}
        </div>
      )}
      <ClubDashboard clubId={clubId} dgView />
      <OfficialBrief clubId={clubId} />
    </div>
  );
}
